var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagRu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Russia (RU)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1218_2391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 0.200195H24V6.2002H0V0.200195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0 6.2002H24V12.2002H0V6.2002Z",
    fill: "#0039A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0 12.2002H24V18.2002H0V12.2002Z",
    fill: "#D52B1E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1218_2391"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.200195,
    width: 24,
    height: 18,
    rx: 1.2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagRu);
export default __webpack_public_path__ + "static/media/FlagRU.f25671779c5b2dcadf11b22752fd1841.svg";
export { ForwardRef as ReactComponent };